<template>
  <div class="fill-height">
    <v-card class="fill-height">
      <v-card-title class="p-1 ">
        <v-chip
            label
            small
            class="ma-2"
            color="secondary"
        >
         تنظیمات هشدار شارژ
          DF-008-1
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.push('/home')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-spacer/>

      <v-card-text>
        <v-row>
          <page-edit :building-list="buildingList" :user-list="userList" :dialog-status.sync="showDialog" :model="model"/>
          <v-col cols="12" md="1" v-if="can('newChargingAlarmSetting') " class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <b-table
            v-if="can('chargingAlarmSettingList')"
            :items="dataItems"
            :fields="columns"
            :per-page=0
            stacked="md"
            show-empty
            responsive striped >

          <template #cell(actions)="row">
            <v-btn depressed small v-if="can('editChargingAlarmSetting')" color="primary" @click="forEdit(row.item.id)"
                   class="mr-1 ">
              ویرایش
            </v-btn>
            <v-btn depressed small v-if="can('deleteChargingAlarmSetting')" color="error" @click="remove(row.item)"
                   class="mr-1 ">
              حذف
            </v-btn>
          </template>
        </b-table>
      </v-card-text>

    </v-card>
  </div>
</template>

<script>

import Service from "./Service";
import PageEdit from "./PageEdit";

export default {
  name: 'ChargingAlarmSetting',
  components: {
    PageEdit
  },
  data() {
    return {
      model: {},
      showDialog: false,
      dataItems: [],
      buildingList: [],
      userList: [],
       modelId:'',
      columns: [
        {key: 'buildingName', label: 'مجتمع '},
        {key: 'minSmsCredit', label: 'حداقل اعتبار پیامکی '},
        {key: 'personNames', label: 'دریافت کنندگان '},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('ChargingAlarmSetting', () => {
      // your code goes here
      this.fillDataItems()
    })
  },

  methods: {
    fetch() {
      Service.getById(this.modelId).then(response => {
        this.model = response.data.model
        this.buildingList = response.data.buildingItems
        if (this.model.id){
          this.getUsers(this.model.buildingId)
        }
        this.showDialog = true;
      })

    },
    forEdit(id){
      this.modelId=id
      this.fetch()
    },
    forNew(){
      this.modelId=''
      this.fetch()
    },
    getUsers(buildingId){
      Service.getUsers(buildingId).then(response=>{
        this.userList=response.data.userList
      })
    },
    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Service.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                }else
                if (response.response.status === 409) {
                  this.$snack({
                    type: 'error',
                    message: 'در حال استفاده میباشد و امکان حذف وجود ندارد!'
                  })
                }
              })
          )
    },
    fillDataItems() {
      Service.getPage().then(response => {
        this.dataItems = response.data.list
      });
    }

  },

  created() {
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

.active {
  color: white;
}

</style>
